import React, { useEffect, useState } from 'react';
import { Card, Button, Row, Col, Spin, App } from 'antd';
import { getAvailabelPlans } from '../../services/plans';

import { createCheckoutSession } from '../../services/stripe';
import { useAuth } from '../../hooks/useAuth';

const { useApp } = App;

const AvailablePlansGrid = () => {
    const { message } = useApp();
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [buyingPlanId, setBuyingPlanId] = useState(null);
    const { user } = useAuth();

    useEffect(() => {
        getAvailabelPlans()
            .then((plansData) => {
                setPlans(plansData);

            }).catch(() => {
            message.error('No se pudo cargar las membresías');
        })
        .finally(() => {
            setLoading(false);
        });
    }, [message]);

    const handleBuyPlan = async (plan) => {
        setBuyingPlanId(plan.id);
        try {
            const { url } = await createCheckoutSession(user.id, plan.id);
            window.location.href = url;
        } catch (error) {
            console.error(error);
            const status = error?.__normalized?.status;
            if (status === 409) {
                message.error('Ya tienes una suscripción activa.');
            } else if (status === 404) {
                message.error('El plan seleccionado no está disponible.');
            } else {
                message.error(error?.__normalized?.message || 'No se pudo iniciar el pago.');
            }
            setBuyingPlanId(null);
        }
    };

  if (loading) return <Spin />;

  return (
    <Row gutter={[16, 16]}>
      {plans.map(plan => (
        <Col xs={24} md={8} key={plan.id}>
          <Card
            title={plan.name}
            bordered={false}
            style={{ height: '100%' }}
          >
            <p>{plan.description}</p>
            <h3>${plan.price}</h3>

            <Button
                type="primary"
                block
                size="large"
                loading={buyingPlanId === plan.id}
                onClick={() => handleBuyPlan(plan)}
                >
                Comprar membresía
            </Button>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default AvailablePlansGrid;
